import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { hashHistory, Link } from 'react-router';

export default class ClassRecordIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      students: [],
      classId: props.location.query.classId,
    };
    // bind this
    this.toRecordDetail = this.toRecordDetail.bind(this);
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    let classId = this.state.classId ? this.state.classId : this.state.role.associatObj.id;
    DataService.getStudentsOfClass(classId).then((students) => {
      DataService.getStudentsStatistics(classId).then((res) => {
        students.forEach(function (student) {
          student.photo_total = 0;
          student.photo_semester = 0;
          student.photo_week = 0;
          student.video_total = 0;
          student.video_semester = 0;
          student.video_week = 0;
          res.forEach(function (statistic) {
            if (student.id == statistic.student_id) {
              student.photo_total = statistic.photo_total;
              student.photo_semester = statistic.photo_semester;
              student.photo_week = statistic.photo_week;
              student.video_total = statistic.video_total;
              student.video_semester = statistic.video_semester;
              student.video_week = statistic.video_week;
            }
          })
        })
        this.setState({
          students: students,
        })
      }).catch((error) => {
      })
    }).catch((error) => {
    })
  }

  componentWillUnmount() {
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  toRecordDetail(e) {
    let studentId = e.currentTarget.dataset.id;
    hashHistory.push(`record/students/${studentId}?classId=${this.state.classId}`);
  }


  render() {
    return (
      <div className="albums-record-index-page">
        <div className="record-wrapper">
          <div className="student-list">
            <div className="student-list-box top">
              <span className="student-name">姓 名</span>
              <div className="student-info">
                <div className="student-record">
                  <div>总 数</div>
                </div>
                <div className="student-record">
                  <div>本学期</div>
                </div>
                <div className="student-record">
                  <div>本 周</div>
                </div>
              </div>
            </div>
            {this.state.students.map(student =>
              <div key={student.id} data-id={student.id} className="student-list-box" onClick={this.toRecordDetail}>
                {student.avatar_url ? <img src={student.avatar_url} /> : <div className="no-avatar"></div>}
                <span className="student-name">{student.full_name}</span>
                <div className="student-info">
                  <div className="student-record">
                    <div>照片{student.photo_total} 视频{student.video_total}</div>
                  </div>
                  <div className="student-record">
                    <div>照片{student.photo_semester} 视频{student.video_semester}</div>
                  </div>
                  <div className="student-record">
                    <div>照片{student.photo_week} 视频{student.video_week}</div>
                  </div>
                </div>
              </div>
            )}
            {(this.state.students.length == 0) && <div className="no-student">暂无学生哦~</div>}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/album/ClassRecordIndexPage.jsx